import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function WhatYouGet() {
  const items = ['10 guías nocturnas paso a paso', 'Micro-tareas diseñadas para cuando no tienes ganas', 'Frases de reconexión (sin cursilerías)', 'Un plan para cada noche — no tienes que pensar', 'Audio opcional para las noches más difíciles'];
  return <section className="py-24 md:py-32 px-4 bg-[#151210]" data-id="element-68">
      <div className="max-w-3xl mx-auto" data-id="element-69">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="text-3xl md:text-4xl font-serif text-center text-[#f5efe6] mb-16" data-id="element-70">
          ¿Qué incluye?
        </motion.h2>

        <div className="space-y-6" data-id="element-71">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: index * 0.15
        }} className="flex items-start gap-4 p-4" data-id="element-72">
              <div className="mt-1 text-[#d4a574]" data-id="element-73">
                <Check size={20} data-id="element-74" />
              </div>
              <p className="text-lg md:text-xl text-[#f5efe6]/90 font-light" data-id="element-75">
                {item}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}